import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const TermsOfService = () => {
  return (
    <Wrapper>
      <div className="content-box">
        <h2>Terms & Conditions</h2>
        <ul>
          <li><strong><NavLink to='/UserT&S' className='text-dark' style={{textDecoration:'none'}}>User Terms & Conditions</NavLink></strong></li>
          <li><strong><NavLink to='/merchantT&S' className='text-dark' style={{textDecoration:'none'}}>Merchant Terms & Conditions</NavLink></strong></li>
          <li><strong><NavLink to='/executiveT&S' className='text-dark' style={{textDecoration:'none'}}>Executive Terms & Conditions</NavLink></strong></li>
        </ul>

      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-color: #e6e6e6;
  padding: 40px 16px;
  display: flex;
  justify-content: center;

  .content-box {
    width: 100%;
    max-width: 1200px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 10px;
    line-height: 1.7;
    color: #333;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-size: 1rem;
  }

  h2 {
    margin-bottom: 24px;
    font-size: 2rem;
    font-weight: 600;
    color: #2a4157;
  }

  h4 {
    margin-top: 28px;
    margin-bottom: 12px;
    color: #444;
    font-size: 1.2rem;
    font-weight: 500;
  }

  ul {
    margin-left: 20px;
    padding-left: 20px;
    list-style: disc;
  }

  li {
    margin-bottom: 8px;
  }

  p {
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    .content-box {
      padding: 25px;
      font-size: 0.95rem;
    }

    h2 {
      font-size: 1.6rem;
    }

    h4 {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 480px) {
    padding: 10px 16px 40px;
    .content-box {
      padding: 20px;
      font-size: 0.9rem;
    }

    h2 {
      font-size: 1.4rem;
    }

    h4 {
      font-size: 1rem;
    }

    ul {
      margin-left: 15px;
    }
  }
`;

export default TermsOfService;
